import { FormattedMessage } from "react-intl";
import ResultTable from "../Results/ResultTable";
import { formatDate } from "../../Utilities/dateUtils";
import { GetResultsByProgramId } from "../../actions/teacherQueries";
import { PacmanLoader } from "react-spinners";

export default function ProgramResultOverview(props) {
  const coursesData = GetResultsByProgramId(props.programId);

  let columnExtensions = [
    { columnName: "name", width: 260 },
    { columnName: "avgScore", width: 250 },
    { columnName: "avgPercDone", width: 250 },
    { columnName: "avgNumTries", width: 250 },
    { columnName: "avgActivityPoints", width: 260 },
    { columnName: "lastRun", width: 180 },
  ];

  let columns = [
    { title: <FormattedMessage id="Name" />, name: "name" },
    { title: <FormattedMessage id="avgModuleTestScore" />, name: "avgScore" },
    { title: <FormattedMessage id="avgPercDone" />, name: "avgPercDone" },
    { title: <FormattedMessage id="avgNumTries" />, name: "avgNumTries" },
    {
      title: <FormattedMessage id="avgActivityPoints" />,
      name: "avgActivityPoints",
    },
    { title: <FormattedMessage id="LastRun" />, name: "lastRun" },
  ];

  if (!coursesData || coursesData.isPending || !coursesData.data) {
    return (
      <div className="inline-pacman-loader">
        <PacmanLoader color="#20a8d8" size={20} />
      </div>
    );
  }

  let resultTableData = [];

  coursesData.data.forEach((course) => {
    let courseToAdd = {
      name: course.courseName,
      id: "c" + course.id,
      parentId: null,
    };
    resultTableData.push(courseToAdd);
    [...course.classes]
      .sort((a, b) => a.name.localeCompare(b.name, "sv"))
      .forEach((classRes) => {
        let classToAdd = {
          name: classRes.name,
          parentId: "c" + course.id,
          avgScore: classRes.averageScore,
          avgPercDone: classRes.donePercentage,
          avgNumTries: classRes.averageNumberOfTimes,
          avgActivityPoints: classRes.averageActivityPoints,
          lastRun:
            classRes.lastRun === null
              ? null
              : formatDate(classRes.lastRun, "PPp"),
        };
        resultTableData.push(classToAdd);
      });
  });

  return (
    <ResultTable
      level="Class"
      tableData={resultTableData}
      columnExtensions={columnExtensions}
      columns={columns}
      rightAlignedColumns={[
        "avgScore",
        "avgPercDone",
        "avgNumTries",
        "avgActivityPoints",
      ]}
    />
  );
}
